import { render, staticRenderFns } from "./CustomerShowOrthoElastic.vue?vue&type=template&id=40c36cd8"
import script from "./CustomerShowOrthoElastic.vue?vue&type=script&lang=js"
export * from "./CustomerShowOrthoElastic.vue?vue&type=script&lang=js"
import style0 from "./CustomerShowOrthoElastic.vue?vue&type=style&index=0&id=40c36cd8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports